import Icon from '@/components/atoms/icon/icon';
import { IconSize } from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import variables from '@/components/organisms/trip-highlights/trip-highlights.variables';
import ShowMore from '@/components/utilities/show-more/show-more';
import styles from './trip-highlights.module.scss';

export interface TripHighlightsProps {
  /** The text to show as headline */
  headline?: string;
  /** The list of highlights to show */
  tripHighlightsItems: {
    description: string;
  }[];
}

const TripHighlights = ({
  headline,
  tripHighlightsItems = [],
}: TripHighlightsProps) => {
  if (tripHighlightsItems?.length === 0 || tripHighlightsItems === null)
    return null;

  return (
    <div className={styles.component}>
      <Typography className={styles.headline} tag="h2" tagStyle="headingMedium">
        {headline}
      </Typography>

      <ShowMore height={200}>
        <div className={styles.highlights}>
          {tripHighlightsItems.map(({ description }, highlightIndex) => (
            <div key={highlightIndex} className={styles.highlight}>
              <div className={styles.decoration}>
                <Icon
                  className={styles.icon}
                  name="StarFilled"
                  size={variables.iconSize as IconSize}
                />
              </div>

              <Typography className={styles.text} tagStyle="bodySmall">
                {description}
              </Typography>
            </div>
          ))}
        </div>
      </ShowMore>
    </div>
  );
};

TripHighlights.displayName = 'TripHighlights';

export default TripHighlights;
